<template>
  <div class="form-group">
    <textarea
      class="form-control"
      rows="5"
      :placeholder="placeholder"
      :id="id"
      :value="modelValue" 
      @input="$emit('update:modelValue', $event.target.value)" 
    ></textarea>
  </div>
</template>

<script>
export default {
  name: "argon-textarea",
  props: {
    id: String,
    placeholder: String,
    modelValue: String, // Asegúrate de que esto esté vinculado correctamente
  },
  emits: ['update:modelValue'], // Asegúrate de que la emisión del evento es correcta
};
</script>
